export default "__VITE_ASSET__brhxWuDt__"